import { Component, OnInit, inject } from '@angular/core';
import * as _ from 'lodash';
import { combineLatest } from 'rxjs';
import { InstructoGroupService, SharePricing, SharePricingService } from 'thkee-common';
import { DataTableComponent } from '../../../../@shared/components/data-table/data-table.component';
import { FormPriceSharesComponent } from '../../../../@shared/components/forms/price-shares/price-shares.component';

@Component({
    selector: 'app-ads',
    templateUrl: './ads.component.html',
    styleUrls: ['./ads.component.scss'],
    imports: [DataTableComponent, FormPriceSharesComponent]
})
export class SharesAdsComponent implements OnInit {
  private sharePricingService = inject(SharePricingService);
  private instructorGroupService = inject(InstructoGroupService);

  title: string = 'Shares';
  sharePricingData: SharePricing[] = [];

  ngOnInit(): void {
    combineLatest([
      this.sharePricingService.getAllSharePricing(),
      this.instructorGroupService.getAllInstructorGroup(),
    ]).subscribe(([sharePricing, group]) => {
      // Update group name of share pricing based on it's instructor group
      let shareData = sharePricing.map((item: any) => {
        if (group['results']) {
          const selectedGroup = _.find(group['results'], { id: item.group });
          if (selectedGroup) {
            return {
              ...item,
              group_name: selectedGroup.group_name,
            };
          }
        }
        return {
          ...item,
        };
      });
      shareData = _.filter(shareData, { share_types: 'ADS' }); // Filter organics
      this.sharePricingData = _.sortBy(shareData, 'id'); // Sort by id
    });
  }
}
